import { render, staticRenderFns } from "./AiAdviceList.vue?vue&type=template&id=4707808a&scoped=true&"
import script from "./AiAdviceList.vue?vue&type=script&lang=ts&"
export * from "./AiAdviceList.vue?vue&type=script&lang=ts&"
import style0 from "./AiAdviceList.vue?vue&type=style&index=0&id=4707808a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4707808a",
  null
  
)

export default component.exports